// @ts-nocheck
import React from 'react';
import {
  yesNoUI,
  yesNoSchema,
  titleUI,
  descriptionUI,
} from 'platform/forms-system/src/js/web-component-patterns';

import FinanciallySoundYesAlert from '../components/FinanciallySoundYesAlert';

/** @type {PageSchema} */
export default {
  uiSchema: {
    acknowledgement10a: {
      ...titleUI('Institution Acknowledgements (4 of 5)'),
      ...descriptionUI(
        <div>
          <p>
            Your facility must be financially sound and able to support its
            obligations to the program you are seeking approval for. If you
            confirm this, you’ll need to submit additional documents
            substantiating your institution’s financial stability.
          </p>
          <va-link
            href="https://www.benefits.va.gov/GIBILL/foreign-School-program-approval-application-package-information.asp"
            text="Learn more about supporting documents for your application"
            external
          />
        </div>,
      ),
      financiallySound: {
        ...yesNoUI({
          title:
            'Is the facility financially sound and fully capable of meeting its commitments?',
          labels: {
            Y: 'Yes',
            N: 'No',
          },
          errorMessages: {
            required: 'You must make a selection.',
          },
        }),
      },
      'view:yesInfo': {
        'ui:description': <FinanciallySoundYesAlert />,
        'ui:options': {
          expandUnder: 'financiallySound',
          expandUnderCondition: true,
        },
      },
      supportingDocuments: {
        'ui:description': (
          <div className="vads-u-margin-top--4">
            <va-additional-info trigger="Examples of supporting financial documentation">
              <p>
                Examples of documentation may include copies of tax returns, or
                financial reports that reports the financial position of the
                institution or establishment, as prepared by any appropriate
                third-party entity.
              </p>
            </va-additional-info>
          </div>
        ),
      },
    },
  },
  schema: {
    type: 'object',
    properties: {
      acknowledgement10a: {
        type: 'object',
        properties: {
          financiallySound: { ...yesNoSchema, title: 'Financially Sound' },
          'view:yesInfo': {
            type: 'object',
            properties: {},
          },
          supportingDocuments: {
            type: 'object',
            properties: {},
          },
        },
        required: ['financiallySound'],
      },
    },
  },
};
